const Backbone = require('backbone')
const _ = require('underscore')

const APP = require('APP')
const GameModel = require('Models/Game')
const user = require('Models/UserModel')

/**
 *
 * @return {Backbone.Collection}
 */
const GamesCollection = Backbone.Collection.extend({
  model: GameModel,

  /**
   * Initing collection with games data
   * @param  {Object} gamesObj [gamesObject from backend]
   */
  init(gamesObj, params) {
    this.ready = true
    this.fungamesCategory = params.fungamesCategory
    this.defaultCategory = params.defaultCategory
    this.mainCategory = params.mainCategory
    const { isRealPlayPermitted } = params.user
    const { isPlayForFunPermitted } = params.user

    _.forEach(gamesObj, (g) => {
      g.id = g.slug
      g.isRealPlayPermitted = isRealPlayPermitted
      g.isPlayForFunPermitted = isPlayForFunPermitted

      this.add(g)
    })

    this.trigger('ready')
    this.listenTo(user, 'sync', this.update)
  },

  canShowFungames() {
    return !APP.IS_ELECTRON
  },

  update(data) {
    _.forEach(data.games, (g) => {
      this.get(g.slug).set('unfinished', g.unfinished)
    })
  },

  /**
   * returns if collection is ready (filed with data)
   * @return {Boolean}
   */
  isReady() {
    return !!this.ready
  },

  /**
   * Getting {num} number of games
   * @param  {Number}  num count of random intems
   * @return {Array}   random items collection
   */
  getRandom(num) {
    let j
    const selected = []
    // var randomGames = {};

    if (num >= this.length) {
      return this.filter()
    }

    const arr = this.pluck('slug')
    for (let i = 0; i < num; i++) {
      j = Math.floor(Math.random() * arr.length)
      while (selected.indexOf(arr[j]) > -1) {
        j = Math.floor(Math.random() * arr.length)
      }
      selected.push(arr[j])
    }

    return this.filter((g) => selected.indexOf(g.get('slug')) > -1)
  },

  /**
   * Ge unfinished games
   * @param  {Boolien}  slugsOnly    if retun only slugs
   * @return {Array}                 unfinished games from collection
   */
  getUnfinished(slugsOnly) {
    const unfinished = this.filter((g) => g.get('unfinished'))

    if (slugsOnly) {
      return unfinished.map((g) => g.get('slug'))
    } else {
      return unfinished
    }
  },

  /**
   * Search games by query
   * @param  {String} q         search query
   * @param  {Object} params    search parameters (example {categorySlug: 'all', sort: })
   * @return {Array}            list of games matching query
   */
  search(q, params) {
    /** @type {Array} All search results */
    let results
    /** @type {Array} Search results with words starts with q
                          example if q = 'mu' then this array only contains
                          games with names started with 'mu' */
    const firstResults = []
    let sortedResults = []
    /** @type {Array} q splited by ' ' and lowercase */

    const words = _.isString(q) ? q.toLowerCase().split(' ') : _.isArray(q) ? q : false
    let ind
    let r
    let fr
    const canShowFungames = this.canShowFungames()

    if (!params) {
      params = {}
    }

    if (params.categorySlug === '') {
      params.categorySlug = undefined
    }

    results = this.filter((g) => {
      r = true
      fr = false

      if (!canShowFungames && g.get('fungameOnly')) {
        return false
      }

      if (params) {
        if (params.categorySlug && _.contains(g.get('category'), params.categorySlug) === false) {
          /** if game is not in category */
          return false
        }
      }

      if (words) {
        r = false
        _.forEach(words, (word) => {
          ind = g.get('searchIndex').indexOf(word)
          if (ind >= 0) {
            if (ind === 0) {
              /** if game name starst with 'word' */
              fr = true
            } else if (ind > 0) {
              r = true
            }
          }
        })
      }

      if (r) {
        return g
      }

      if (fr) {
        /** add games with names started with 'word' add to
         * firstResults array */
        firstResults.push(g)
      }

      return false
    })

    if (firstResults.length > 0) {
      /** add firstResults array in the begining of results */
      results = firstResults.concat(results)
    }

    if (params && params.sort && params.order) {
      /** sorting */
      sortedResults = _.sortBy(results, (obj) => obj.get(params.sort))
      return params.order !== 'desc' ? sortedResults : sortedResults.reverse()
    }

    return results
  },
})

const gc = new GamesCollection()
module.exports = gc
